<template>
  <div v-if="!isApp" class="thank-you">
    <div class="image"><img src="@/assets/images/img_kura_app.png" alt="" /></div>
    <footer class="footer">
      <ul>
        <li>
          <a
            href="https://apps.apple.com/app/apple-store/id942355925?pt=118305884&ct=SOWeb&mt=8"
            target="_blank"
          >
            <img src="@/assets/images/btn_app_store.svg" alt="" />
          </a>
        </li>
        <li>
          <a
            href="https://play.google.com/store/apps/details?id=jp.co.kura_corpo&utm_source=soweb&utm_campaign=app_dl"
            target="_blank"
          >
            <img src="@/assets/images/btn_google_play.svg" alt="" />
          </a>
        </li>
      </ul>
    </footer>
  </div>
</template>
<script>
export default {
  computed: {
    isApp() {
      return process.env.VUE_APP_TYPE === 'app'
    },
  },
}
</script>
<style lang="scss" scoped>
.thank-you {
  min-height: 100vh;
  text-align: center;
  padding: 0 0 20px;
  background: #57a7b9;
  .image {
    max-width: 480px;
    margin: auto;
  }
}
.footer {
  padding: 0 20px;
  ul {
    display: flex;
    justify-content: space-between;
    max-width: 334px;
    margin: 0 auto;
    padding: 10px;
    border: 1px solid rgba(255, 255, 255, 0.6);
  }
  li {
    list-style: none;

    &:first-child {
      width: 46%;
    }

    &:last-child {
      width: 52%;
    }

    img {
      width: 100%;
    }
  }
}
</style>
